import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SearchBox.css';

class SearchBox extends Component {

  constructor (props) {
    super(props);

    this.state = {
      searchTerm: ''
    };
  }

  handleClear = ($event) => {
    $event.preventDefault();
    this.setSearchTerm('');
  };

  handleSearchTermChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    this.setSearchTerm(searchTerm);
  };

  setSearchTerm = (term) => {
    this.setState({
      searchTerm: term || ''
    }, () => {
      this.props.updateSearchFilter(term || '');
    });
  };

  render () {
    const { searchTerm } = this.state;
    return (
      <form className="search-box fix-ie">
        <fieldset className="form-group fix-ie">
          <div className="row no-gutters d-flex h-100">
            <i className="material-icons m-auto search-icon">search</i>
            <input
              type="text"
              className="pop-form-control m-auto"
              placeholder="Search"
              value={ searchTerm }
              onChange={ this.handleSearchTermChange } />
            <div
              className={ `m-auto ${searchTerm ? 'clickable' : 'invisible'}` }
              onClick={ this.handleClear }>
              <i className="material-icons search-icon">close</i>
            </div>
          </div>
        </fieldset>
      </form>
    );
  }
}

SearchBox.propTypes = {
  filterBySearchTerm: PropTypes.func
};

export default SearchBox;
